var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 138.942,
    height: 44.743,
    viewBox: "0 0 929.78 398.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 716.36,
    cy: 328.35,
    r: 69.81,
    fill: "#183f75"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 187.14,
    cy: 328.37,
    r: 69.81,
    fill: "#183f75"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M925.85,300.49s3.56-40.81,1.34-118.53c-2.26-77.75-17.84-141.02-23.86-159.99C897.33,3,890.93.2,870.83.02c-20.06-.21-93.5,1.81-216.86,1.81s-289.78,2.67-401.26,2.67c-69.36.01-59.19-4.49-80.18,21.42-21.45,26.48-50.88,99.89-68.72,116.23-17.84,16.33-93.75,13.16-94.58,46.96-.79,31.01-.1,78.45.49,108.63.05,2.71-9.78,6.27-9.72,8.64.75,28.83,6.4,37.46,33.79,39.85,26.12,2.33,58.82,3.66,68.3,4.01,1.34.07,2.43-1.1,2.26-2.43-2.23-18.86.07-103.91,83.26-103.91s83.78,86.62,83.92,103.91c0,1.68,1.34,2.98,3.01,2.98h351.45c1.06,0,1.88-.82,1.85-1.85-.34-14.24.89-105.04,88.4-105.04s87.07,85.59,86.59,103.6c-.03,1.78,1.44,3.22,3.22,3.15,14.21-.68,69.84-3.39,94.63-5.82,28.55-2.84,29.1-20.47,29.1-30.23s-3.94-14.11-3.94-14.11h.01ZM305.16,43.84c-1.64,8.03-7.79,43.72-12.84,64.12-1.91,7.72-9.61,13.23-18.54,13.29-31.78.21-97.57.27-97.23-.79.43-1.35,2.73-6.45,3.13-11.83.69-9.08-19.66-4.08-32.79-3.41,8.05-17.61,18.86-43.93,37.8-57.81,18.21-13.34,45.62-8.49,71.65-8.57l42.39-.13c5.2-.05,7.12,1.76,6.43,5.12h0ZM574.17,106.5c0,12.5-6.3,14.82-12.91,14.82h-195.74c-23.21,0-19.8-15.69-19.8-15.69l.19-54.5s-2.7-12.43,12.5-12.43h202.82c8.11,0,12.94,2.53,12.94,13.83v53.96h0ZM853.34,121.36h-221.48c-8.9,0-14.17-2.36-14.17-12.94v-53.86c0-13.28,7.46-15.82,15.27-15.82h178.38c27.39,0,44.92-2.02,48.58,19.21,4.42,25.51,8.76,43.45,9.93,51.8.75,5.48.1,11.61-16.5,11.61h-.01Z",
    fill: "#183f75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBus);
export default __webpack_public_path__ + "static/media/Bus.6f57b574649f85f785339ea7a53ed88a.svg";
export { ForwardRef as ReactComponent };